module.exports = __webpack_public_path__ + "img/symbol_3.73fdfc7e.png";